// extracted by mini-css-extract-plugin
export default {"image":"image_image__DLpCq","in":"image_in__WfT7X"};